import { FC, memo } from 'react';
import { Box } from '@material-ui/core';
import {
  WbLink,
  WbTruncatedTypographyWrapper,
} from '@agilelab/plugin-wb-platform';
import { WbInfoTooltip, Severity } from '@agilelab/plugin-wb-platform';

interface EntityCardTitleProps {
  name: string;
  loading: boolean;
  route: string;
  error?: string;
}

export const EntityCardTitle: FC<EntityCardTitleProps> = memo(
  ({ name, loading, route, error }) => {
    return loading ? (
      <WbTruncatedTypographyWrapper
        value={name}
        maxLines={1}
        style={{ fontWeight: 700 }}
        enableTooltip
        placement="top-start"
      />
    ) : (
      <Box
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          marginBottom: 4,
        }}
      >
        <WbLink to={route}>
          <WbTruncatedTypographyWrapper
            value={name}
            maxLines={1}
            style={{ fontWeight: 700 }}
            enableTooltip
            placement="top-start"
          />
        </WbLink>
        {error && (
          <WbInfoTooltip
            severity={Severity.Error}
            title={error}
            iconSize="inherit"
          />
        )}
      </Box>
    );
  },
);

EntityCardTitle.displayName = 'EntityCardTitle';
